import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, actionText, route, variant = "default" }) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-smooth">
      <div className="flex flex-col h-full">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
            <Icon name={icon} size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <h3 className="text-base md:text-lg font-semibold text-foreground">{title}</h3>
          </div>
        </div>
        
        <p className="text-sm md:text-base text-muted-foreground mb-6 flex-1">
          {description}
        </p>
        
        <Button 
          variant={variant}
          onClick={handleAction}
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
        >
          {actionText}
        </Button>
      </div>
    </div>
  );
};

export default QuickActionCard;